<template>
    <div class="slide-comments" data-spm-stop="init">
        <!-- 顶部header -->
        <div class="header" @click="checkAllComments">
            <div class="comment-title">
                <span>评论</span>
                <span class="comment-total" v-if="total">{{ total }}</span>
            </div>
            <div class="check-all">
                全部
                <div class="icon-next"></div>
            </div>
        </div>
        <!-- 外露评论 -->
        <div v-if="isRequestFinish" class="comment-content" :data-spm="spmCCode_content" data-spm-stop="init">
            <div 
                v-if="commentList && commentList.length" 
                class="has-comment" 
                id="comment-wrapper" 
                @click="checkAllComments">
                <div 
                    class="comment-item" 
                    v-for="(item, index) in commentList"
                    :key="index"
                    data-spm-type="resource"
                    data-spm-strict="true">
                    <img :src="item.avatar" class="avatar" />
                    <CommentText :text="item.richContent" class="comment-cnt"></CommentText>
                </div>
            </div>
            <div v-else class="no-comment" @click="handleFirstComment">
                <div class="no-comment-tips">还没有人评论过，快来抢首评</div>
                <div class="divide-line"></div>
                <div class="edit-icon"></div>
                <div class="write-comment">写评论</div>
            </div>
        </div>
        <CommentLayer 
            v-if="isRenderCommentLayer"
            :comments="commentData" 
            :articleId="articleId" 
            :accountId="accountId"
            :articleTitle="articleTitle"
            :isLogin="isLogin" 
            :userInfo="userInfo"
            :height="commentLayerHeight"
            @handleLayerShow="handleLayerShow">
        </CommentLayer>
    </div>
</template>
<script>
import SlideV from '@/utils/slide-v';
import Util from '@/utils/util';
import { getComments } from '@/js/article-main/request/api';
import { getUserInfo } from '@/js/request/uisRequest';
import Vue from 'vue';
import CommentLayer,{eventEmitter as commentEventEmitter, eventNameMap as commentEventNameMap} from 'common-components/lib/commentLayer/index.js'
import 'common-components/lib/commentLayer/index.css'
import CustomTransition from './custom-transition.vue';
import { sendAction } from '@/utils/spmUtil';
import { acodeConfig } from '@/config/spmConfig';
import CommentText from 'common-components/lib/commentText/index'
import 'common-components/lib/commentText/index.css'

export default {
    name: "SlideComments",
    props: {
        articleId: {
            type: String | Number,
            default: ''
        },
        accountId: {
            type: String | Number,
            default: ''
        },
        articleTitle: {
            type: String,
            default: ''
        },
        size: {
            type: Number,
            default: 3
        },
    },
    data() {
        return {
            commentData: {},
            isRequestFinish: false, // 请求是否结束
            isRenderCommentLayer: false, // 是否加载评论浮层，避免反复渲染
            isLogin: false,
            userInfo: null,
            commentLayerHeight: 0, // 评论浮层高度
        }
    },
    components:{
        CommentLayer,
        CustomTransition,
        CommentText,
    },
    computed: {
        commentList() {
            const comments = this.commentData?.comments?.map(item => {
                item.avatar = this.commentData?.users?.[item.userId]?.avatar
                return item
            }) || []
            const result = comments?.filter(comment => {
                return comment.content
            })
            return result
        },
        total() {
            return this.commentData?.outerCmtSum
        },
        spmCCode_content() {
            return 'comments'
        },
    },
    async mounted() {
        // 设置评论浮层高度
        this.setCommentLayerHeight()
        this.commentData = await this.getComments()
        this.isRequestFinish = true
        this.$nextTick(() => {
            const slideParam = {
                wrapperSelector: '#comment-wrapper',
                //单帧停留时间，目前为5秒
                slideTime: 1000 * 5,
                //动画时间，目前为400毫秒
                animateTime: 400,
                itemSelector: '.comment-item',
                slideCallback: () => {
                    window.sohuSpm?.reScan?.()
                },
            }
            this.commentList?.length > 1 && new SlideV(slideParam)
            Util.domDidChange({
                target: this.spmCCode_content
            })
        })
        this.initUserInfo()
        const that = this
        // 首评假显露出
        commentEventEmitter.on(commentEventNameMap.publishCommentSuccess, (newComment) => {
            if(that.commentList?.length <= 0 && newComment){
                that.commentData.comments?.push(newComment)
                const userId = newComment?.userId
                this.commentData.users[userId] = {
                    avatar: this.userInfo?.avatar,
                    userCenterId: this.userInfo?.userId,
                    userId: userId,
                    userName: this.userInfo?.nickname
                }
            }
        })
    },
    methods: {
        async getComments() {
            const param = {
                sourceId: `mp_${this.articleId}`,
                pageNo: 1,
                pageSize: this.size,
                type: 0,
                accountId: this.accountId,
            }
            try {
                const res = await getComments(param)
                let result = res?.data
                // 如果数据为空，或者空对象
                if(!result || JSON.stringify(result) === '{}'){
                    result = {
                        comments: [],
                        replies: {},
                        users: {},
                    }
                }
                return result
            } catch (error) {
                console.log('获取热门评论失败', error)
            }
        },
        setCommentLayerHeight(){
            const videoContent = document.querySelector('#videoContent')
            const videoContentBottom = videoContent?.getBoundingClientRect()?.bottom
            const height = window.innerHeight - videoContentBottom
            height && ( this.commentLayerHeight = height )
        },
        showCommentLayer() {
            this.isRenderCommentLayer = true
            this.setCommentLayerHeight()
        },
        /**
         * @description 点击展开全部评论事件
         */
        checkAllComments(){
            this.showCommentLayer()
            sendAction({
                acode: acodeConfig.checkAllComments
            })
        },
        /**
         * @description 首次评论
         */
        handleFirstComment(){
            this.showCommentLayer()
            this.$nextTick(()=> {
                commentEventEmitter.emit(commentEventNameMap.showCommentPopup)
            })
        },
        async loadLayer() {
            try {
                const CommentLayer = await import(/* webpackChunkName: "CommentLayer" */'common-components/lib/commentLayer/index.js')
                await import(/* webpackChunkName: "CommentLayer" */'common-components/lib/commentLayer/index.css')
                const defaultComp = CommentLayer.default
                Vue.component('CommentLayer', {
                    extends: defaultComp,
                    props: {
                        comments: {
                            type: Object,
                            default: () => {
                                return null
                            }
                        },
                        articleId: {
                            type: String | Number,
                            default: "",
                            required: false,
                        },
                        accountId: {
                            type: String | Number,
                            default: 0,
                            required: false,
                        },
                        isLogin: {
                            type: Boolean,
                            default: () => false,
                        },
                        spmCCode: {
                            type: String,
                            default: "",
                        },
                        userInfo: {
                            type: Object,
                            default: () => {
                                return {}
                            }
                        }
                    }
                })
                this.$nextTick(() => {
                    this.isRenderCommentLayer = true
                })
            } catch (error) {
                console.log('加载评论浮层失败', error)
            }
        },
        async initUserInfo() {
            try {
                const res = await getUserInfo()
                if(res?.code == 1){
                    this.userInfo = res?.data
                    this.isLogin = true
                }
            } catch (error) {
                this.isLogin = false
            }
        },
        handleLayerShow(isShow){
            this.isRenderCommentLayer = isShow
        }
    }
}
</script>
<style lang="less" scoped>
.slide-comments {
    padding: 16px 24px;
    box-sizing: border-box;
    background: #F8F8F8;
    position: relative;
    min-height: 162px;

    .header {
        height: 42px;
        /*px*/
        display: flex;
        justify-content: space-between;
        align-items: center;

        .comment-title {
            font-size: 0px;
            display: flex;
            align-items: center;
            span{
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 28px;/*px*/
                color: #111111;
                line-height: 40px; /*px*/
                text-align: left;
                font-style: normal;
            }

            .comment-total {
                display: inline-block;
                margin-left: 8px;/*px*/
            }
        }

        .check-all {
            position: absolute;
            top: 16px;
            /*px*/
            right: 16px;
            /*px*/
            height: 42px;
            /*px*/
            display: inline-flex;
            align-items: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 28px; /*px*/
            color: #999999;
            line-height: 40px; /*px*/
            text-align: center;
            font-style: normal;

            .icon-next {
                margin-left: 4px;
                /*px*/
                width: 28px;
                /*px*/
                height: 28px;
                /*px*/
                background-image: url("../less/images/icon_vision_next.png");
                background-size: 100% 100%;
            }
        }
    }

    .comment-content {
        margin-top: 24px;

        /*px*/
        .has-comment {
            height: 96px;
            /*px*/
            overflow: hidden;

            .comment-item {
                position: relative;
                height: 100%;
                display: flex;
                align-items: center;
            }

            .avatar {
                width: 56px;
                /*px*/
                height: 56px;
                /*px*/
                border-radius: 50%;
                margin-right: 16px;
                /*px*/
            }

            .comment-cnt {
                font-size: 32px; /*px*/
                /*px*/
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #111111;
                line-height: 48px; /*px*/
                /*px*/
                text-align: left;
                font-style: normal;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                /* autoprefixer:off */
                -webkit-box-orient: vertical;
                /* autoprefixer:on */
                -webkit-line-clamp: 2;
                max-height: 96px; /*px*/
                /deep/ .emoji{
                    font-size: 42px;/*px*/
                    vertical-align: text-bottom;
                }
                /deep/ .comment-at{
                    color: #143CA8;
                }
            }
        }

        .no-comment {
            /*px*/
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;

            .no-comment-tips {
                font-size: 28px; /*px*/
                /*px*/
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 40px; /*px*/
                /*px*/
            }

            .divide-line {
                width: 2px;
                /*px*/
                height: 24px;
                /*px*/
                background: #EBEBEB;
                margin: 0px 16px;
            }

            .edit-icon {
                width: 28px;
                height: 28px;
                background: url('../less/images/icon_edit_666666.png') no-repeat center;
                background-size: contain;
                margin-right: 8px;
            }

            .write-comment {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 28px; /*px*/
                color: #666666;
                line-height: 40px; /*px*/
                text-align: justify;
                font-style: normal;
            }
        }
    }
}
</style>